import styled from "styled-components";

export const Title = styled("h4")`
  margin: 0px;
  font-size: 16px;
`;

export const Card = styled("div")`
  height: 450px;
  width: 100%;
  background-color: #f7f3f3;
  padding: 15px;
  border-radius: 20px;
`;
